export const baseURL = process.env.VUE_APP_API_ROOT
